
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"200.745","height":"103.698","viewBox":"0 0 200.745 103.698"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#ff006c","stroke-width":"3"}},[_c('g',{attrs:{"transform":"translate(0 45.697)","fill":"#fff"}},[_c('rect',{attrs:{"width":"200","height":"58","rx":"29","stroke":"none"}}),_c('rect',{attrs:{"x":"1.5","y":"1.5","width":"197","height":"55","rx":"27.5","fill":"none"}})]),_c('path',{attrs:{"fill":"none","d":"M103.376 0v26.874M71.403 1.168l5.842 26.874M135.349 1.168l-5.842 26.874"}}),_c('path',{attrs:{"d":"M168.917 5.586l-13.232 22.457M38.22 5.586l13.232 22.457M7 19.512l19.439 16.709M199.767 19.512l-19.439 16.709","fill":"rgba(0,0,0,0)"}})])])
          )
        }
      }
    